module.exports = {"411324001":"涅阳街道","411324002":"雪枫街道","411324003":"玉都街道","411324101":"石佛寺镇","411324102":"晁陂镇","411324103":"贾宋镇","411324104":"侯集镇","411324105":"老庄镇","411324106":"卢医镇","411324107":"遮山镇","411324108":"高丘镇","411324109":"曲屯镇","411324110":"枣园镇","411324111":"杨营镇","411324112":"安字营镇","411324113":"张林镇","411324114":"柳泉铺镇","411324115":"彭营镇","411324303":"二龙乡","411324306":"王岗乡","411324309":"马庄乡","411324315":"郭庄回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411324.json
// module id = 1501
// module chunks = 0